import store from '@/state/store'

export const TMS_MARKETING_USER_FILTER = "position.name in ('Sales/Marketing','TMS Marketing')"

export function isTmsMarketingUser() {
  const whoami = store.state.identity.whoami
  if (!whoami) return false

  const normalize = (value) => String(value || '').trim().toLowerCase()
  const position = normalize(whoami.position)
  const groups = Array.isArray(whoami.groups) ? whoami.groups : []
  const scopes = Array.isArray(whoami.scopes) ? whoami.scopes : []
  const groupNames = groups.map((group) => normalize(group.name))
  const customFeatureMgm = store.getters['identity/getFeatureFlagValue']?.('customFeature.mgm')
  const companyId = whoami.companyId

  const hasTmsUserGroupScope = scopes.some((scope) => scope.startsWith('tms-user-group:'))
  const hasSuperUserOperationalGroup = groupNames.includes('super user operational')
  const hasMgmFeatureFlag =
    Array.isArray(customFeatureMgm?.company_id) && customFeatureMgm.company_id.includes(companyId)
  const isTmsMarketingPosition = position === 'tms marketing'

  return (
    hasTmsUserGroupScope &&
    hasSuperUserOperationalGroup &&
    hasMgmFeatureFlag &&
    isTmsMarketingPosition
  )
}
